<template>
  <div id="components-layout-demo-top-side">
    <v-layout>
      <v-header>
        <div class="logo"
             style="font-size: 18px !important;
    color: white;
    line-height: 18px;
    display: flex;
    align-items: center;">证件照研究院后台</div>
        <div style="color:#fff;float:right">
          <span>{{checked?'测试环境':'正式环境'}}</span>
          <v-switch v-model="checked"
                    @change="changeServerMode"></v-switch>
          <span style="color:#f8f8f8;padding-left:20px;">{{accountName}}</span>
          <a style="color:#f8f8f8;padding-left:20px;"
             @click="quit">退出</a>
        </div>
      </v-header>
      <v-layout>
        <v-sider :width="200"
                 style="background: #fff">
          <v-menu mode="inline"
                  @item-click="itemClick"
                  @submenu-click="submenuClick"
                  :data="menuData2"
                  style="height:100%"></v-menu>
        </v-sider>
        <v-layout style="padding:0 24px 24px">
          <v-breadcrumb style="margin:12px 0">
            <v-breadcrumb-item>证件照研究院后台</v-breadcrumb-item>
            <v-breadcrumb-item>{{fitstName}}</v-breadcrumb-item>
            <v-breadcrumb-item>{{secondName}}</v-breadcrumb-item>
          </v-breadcrumb>
          <v-content style="background: #fff; padding: 24px; margin: 0; min-height: 280px">
            <transition name="fade"
                        mode="out-in">
              <router-view></router-view>
            </transition>
          </v-content>
        </v-layout>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import { localStorage } from '@/deps/utils'
export default {
  data () {
    return {
      checked: false,
      accountName: '',
      fitstName: '',
      secondName: '',
      menuData2: [{
        name: '概况',
        icon: 'bar-chart',
        url: '/main'
      }, {
        name: '订单',
        icon: 'shopping-cart',
        children: [{
          name: '订单查询',
          url: '/main/order'
        }, {
          name: '成单规格',
          url: '/main/orderRanking'
        }]
      }, {
        name: '规格',
        icon: 'tags-o',
        children: [{
          name: '规格管理',
          url: '/main/formatManager'
        }, {
          name: '热门规格排序',
          url: '/main/formatHot'
        }]
      }, {
        name: '运编',
        icon: 'notification',
        url: '/main/operation'
      }, {
        name: '开票订单',
        icon: 'file-text',
        url: '/main/invoices'
      }, {
        name: '充值',
        icon: 'pay-circle',
        url: '/main/recharge'
      }, {
        name: '购券中心',
        icon: 'shop',
        url: '/main/shopping'
      }, {
        name: '评价中心',
        icon: 'frown-o',
        url: '/main/appraise'
      }, {
        name: '咨询中心',
        icon: 'link',
        url: '/main/consult'
      }, {
        name: '活动中心',
        icon: 'team',
        url: '/main/activities'
      }, {
        name: '工单反馈',
        icon: 'bell',
        url: '/main/workSheet'
      }]
    }
  },
  methods: {
    changeServerMode () {
      this.$store.commit('changeFlag')
    },
    itemClick (s) {
      console.log(s)
      this.$router.push(s[s.length - 1].url)
      if (s.length === 1) {
        this.fitstName = s[0].name
        this.secondName = ''
      } else {
        this.fitstName = s[0].name
        this.secondName = s[s.length - 1].name
      }
    },
    submenuClick (s) {
      console.log(s)
    },
    quit () {
      sessionStorage.removeItem('account_name')
      axios.get('dev/logout')
      this.$router.push('/')
    }
  },
  created () {
    if (this.$store.state.serverMode === 'formal') this.checked = false
    else this.checked = true
    let path = this.$route.path
    this.menuData2.forEach((item) => {
      if (item.hasOwnProperty('children')) {
        item.children.forEach((i) => {
          if (i.url === path) {
            this.fitstName = item.name
            this.secondName = i.name
          }
        })
      }
      if (path === item.url) {
        this.fitstName = item.name
      }
    })
    this.accountName = localStorage.getItem('account_name')
  }
}
</script>

<style>
.ant-layout {
  min-height: calc(100vh - 64px);
}
.ant-layout-header {
  background-color: #202020;
}
#components-layout-demo-top-side .logo {
  /* width: 120px; */
  height: 31px;
  /* background: #333; */
  border-radius: 6px;
  margin: 16px 28px 16px 0;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/main/main.vue